import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';

const deleteLocation = {
  name: 'deleteLocation',
  state: {
    loading: false,
    error: '',
  },
  reducers: {
    deleteRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
      };
    },

    deleteSucceeded(state) {
      return {
        ...state,
        loading: false,
        error: '',
      };
    },

    deleteFailed(state, payload) {
      return {
        ...state,
        loading: false,
        error: payload,
      };
    },
  },
  effects: (dispatch) => ({
    async removeLocation(id) {
      try {
        this.deleteRequested();
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const orgId = userInfo?.org_id;
        const url = `savvy/locations/${id}`;
        const response = await http.delete(url);
        const displayResponse = await http.get(`savvy/displays/lookupDisplays/${orgId}`);
        const locationResponse = await http.get(`savvy/locations/lookup/${orgId}`);
        if (response && response.data) {
          if (locationResponse && locationResponse?.data?.data.length === 0)
            dispatch.ProgressStepDSO.DeleteDSOProgressStep(1);
          else if (displayResponse?.data?.data?.length === 0)
            await dispatch.ProgressStepDSO.DeleteDSOProgressStep(3);
          this.deleteSucceeded();
          dispatch({
            type: 'helper/show',
            payload: {
              type: 'success',
              message: 'Location deleted successfully!',
              show: true,
            },
          });
        }
      } catch (err) {
        this.deleteFailed(err.message);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: responseMessageHandler.show(err.message),
            show: true,
          },
        });
      }
    },
  }),
};

export default deleteLocation;


